import React from "react";
import { strings } from "../../localization";
import { Grid, skinVars, Text3 } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { formatAmount, formatPercentage } from "../../utils/formatters";
import { TextListItem } from "../TextListItem";

interface IProps {
	anticipationValue?: number;
	anticipationDate?: string;
	anticipationYears: number;
	blockedFGTSValue: number;
	contractFees: number;
	IOF: number;
	monthFees: number;
	yearsFees: number;
	tacAmount: number;
}

export const ContractValuesDetails: React.FC<IProps> = observer((props) => {
	const { anticipationValue, anticipationDate, anticipationYears, blockedFGTSValue, contractFees, IOF, monthFees, yearsFees, tacAmount } = props;

	const { title, helpText, fields, helpTacAmount } = strings.components.ContractValuesDetails;

	return (
		<Grid gap={16}>
			<Text3 medium color={skinVars.colors.backgroundBrand}>
				{title}
			</Text3>
			{anticipationDate && (
				<TextListItem name={fields.anticipationDate} description={anticipationDate}/>
			)}
			{anticipationValue && (
				<TextListItem name={fields.anticipationValue} description={formatAmount(anticipationValue)} />
			)}
			<TextListItem name={fields.blockedValue} description={formatAmount(blockedFGTSValue)} tooltipText={helpText} />
			<TextListItem
				name={fields.anticipationYears}
				description={`${anticipationYears > 1 ? `${anticipationYears} anos` : `${anticipationYears} ano`}`}
			/>
			<TextListItem name={fields.contractFees} description={formatAmount(contractFees)} />
			<TextListItem name={fields.yearFees} description={formatPercentage(yearsFees) + " a.a"} />
			<TextListItem name={fields.monthFees} description={formatPercentage(monthFees) + " a.m"} />
			<TextListItem name={fields.tacAmount} description={formatPercentage(tacAmount)} tooltipText={helpTacAmount} />
			<TextListItem name={fields.iof} description={formatAmount(IOF)} />
		</Grid>
	);
});
